export enum CompletionCodes {
  UnknownCard = 801,
  DisposalCanceled = 802,
  Disposal = 804
}